export default __webpack_public_path__ + "static/media/5.24682fb9.jpg";